// extracted by mini-css-extract-plugin
module.exports = {"wrap":"hk-z","heading":"ik-z"};